import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const ReferenceDevice = model.views(views);

export interface IReferenceDevice extends Instance<typeof ReferenceDevice> {}

export default ReferenceDevice;
